import type { FaireProductEntity } from "../../entity_types/product";

export const p_cdh4um42sj: FaireProductEntity = {
  token: "p_cdh4um42sj",
  type: "product",
  name: "Troll Doll Fuck Refrigerator Magnet",
  brandToken: "b_nwecvb9e2v",
  brandName: "Enchanted Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/88848c451d25ff9c0ad06c0c1458949ae5a1c1fea8d5be98c497b786e31d26a5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0e46a9b8818bbd85a4dfc631da62ba7dbdac67ea9cb7da19cc348a84df1daf7b.png",
    "https://cdn.faire.com/fastly/2aef732608c21b189f886eeea0ae3efac6cd9d34e937f111d878dbda6ba4a660.png",
    "https://cdn.faire.com/fastly/11b6585e1d2e2dd02f6aa8005e8839bff146b277e26809f7dd30c77eb0d72cce.png",
  ],
  priceDollars: 6.91,
  description:
    "Add some bold humor and retro charm to your space with our Troll Doll Fuck Magnet, the unapologetically cheeky desk buddy you didn’t know you needed. Featuring vibrant hair colors and a laser-cut wooden word that says exactly how you (sometimes) feel, this quirky magnet is a conversation starter for any setting. Whether it's stuck to your fridge, file cabinet, or locker, it’s guaranteed to turn heads and provoke grins.\n\n * Handmade By Us\n\n * Strong magnet works great on fridges, file cabinets, lockers, and more\n\n * Laser-cut wood accent spells “FUCK” for a bold, playful vibe\n\n\n * Perfect gag gift or desk accessory for those with a wicked sense of humor\n\n\nPlease note: Colors vary, making each piece one-of-a-kind. \n",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:36.894Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
